import React from "react";
const Tie = ({
  eventDetails,
  tieData,
  setBetSlipDetails,
  tieBook,
  onChildRuleShow
}) => {
  if (tieBook != undefined) {
  }

  const showRules = () => {
    onChildRuleShow();
  };

  // runner1
  let r1b = 0;
  let r1l = 0;
  let rate1 = 0;
  let rate2 = 0;

  let rnr1s = 0;
  let rnr2s = 0;

  let team1Status = "SUSPENDED";
  let team2Status = "SUSPENDED";

  // runner2
  let r2b = 0;
  let r2l = 0;
  let rate3 = 0;
  let rate4 = 0;

  let sectionId1 = 0;
  let sectionId2 = 0;
  let childCatMid = "";
  if (tieData !== null && tieData !== undefined) {
    let finalTieData = tieData;

    r1b = finalTieData.r1b;
    r1l = finalTieData.r1l;

    rate1 = finalTieData.rate1;
    rate2 = finalTieData.rate2;

    rate3 = finalTieData.rate3;
    rate4 = finalTieData.rate4;

    r2b = finalTieData.r2b;
    r2l = finalTieData.r2l;

    sectionId1 = finalTieData.selectionId1;
    sectionId2 = finalTieData.selectionId2;
    childCatMid = finalTieData.cat_mid;
  }

  if (tieBook !== null && tieBook !== undefined) {
    if (tieBook.rnr1s !== undefined) {
      rnr1s = parseInt(tieBook.rnr1s);
    }

    if (tieBook.rnr2s !== undefined) {
      rnr2s = parseInt(tieBook.rnr2s);
    }
  }

  const showBetSlip = (betType, teamName, sid, rate, childCatMid) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      market_type: "tie",
      childId: childCatMid
    });
  };

  return (
    <div id="parent_tie_div" style={{ display: "" }}>
      <div className="market-titlebar">
        <p className="market-name">
          <span className="market-name-badge">
            <i className="market-name-icon">
              <img
                src="/assets/images/time-img.png"
                style={{
                  filter: "invert(100%)",
                  marginTop: "-8px",
                  marginLeft: "-1px"
                }}
              />
            </i>
            <span>
              Tie Match{" "}
              <span style={{ textTransform: "initial" }}>(MaxBet: 2M)</span>{" "}
            </span>{" "}
            <span className="rules-badge" onClick={() => showRules()}>
              <i className="fa fa-info-circle"></i>
            </span>
          </span>
        </p>
        <div className="market-overarround">
          <span></span>
          <strong>Back</strong>
        </div>
        <div className="market-overarround market-overarround-lay">
          <strong>Lay</strong>
        </div>
      </div>

      <div className="market-runners">
        <div className="runner-runner">
          <h3 className="runner-name">
            <div className="runner-info">
              <span className="clippable runner-display-name">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <h4
                          style={{
                            marginBottom: "0px",
                            fontSize: "16px",
                            fontWeight: "600"
                          }}
                          className="clippable-spacer"
                        >
                          Yes
                        </h4>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{
                            float: "left",
                            fontSize: "15px",
                            color: rnr1s >= 0 ? "green" : "red"
                          }}
                        >
                          {rnr1s !== 0 ? <span>{rnr1s}</span> : ""}
                        </div>
                        <div style={{ marginLeft: "10px", display: "none" }}>
                          &nbsp;&nbsp; <span></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </h3>
          <div className="price-row-box-new">
            <a
              className="price-price price-back"
              style={{ background: "var(--theme-bg-color)" }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-back"
              style={{ background: "var(--theme-bg-color)" }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-back mb-show"
              data-team=""
              data-market-type="tie"
              data-bm-sr="1"
              style={{ backgroundColor: "rgb(141, 210, 240)" }}
              onClick={() =>
                showBetSlip("b", "Yes", sectionId1, r1b, childCatMid)
              }
            >
              <div id="runner1b1span_tie">
                <span className="price-odd">{r1b}</span>
                <span className="price-amount">{rate1}</span>
              </div>
            </a>

            <a
              className="price-price price-lay ml-4 mb-show"
              data-team=""
              data-market-type="tie"
              data-bm-sr="1"
              style={{ backgroundColor: "rgb(254, 175, 178)" }}
              onClick={() =>
                showBetSlip("l", "Yes", sectionId1, r1l, childCatMid)
              }
            >
              <div id="runner1l1span_tie">
                <span className="price-odd">{r1l}</span>
                <span className="price-amount">{rate2}</span>
              </div>
            </a>

            <a
              className="price-price price-lay"
              style={{ background: "#fce3e4" }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-lay mr-4"
              style={{ background: "#fce3e4" }}
            >
              <div>&nbsp;</div>
            </a>

            <div
              className="suspended-overlap"
              style={{ display: team1Status == "ACTIVE" ? "" : "none" }}
            >
              Suspended
            </div>
          </div>
        </div>

        <div className="runner-runner">
          <h3 className="runner-name">
            <div className="runner-info">
              <span className="clippable runner-display-name">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <h4
                          style={{
                            marginBottom: "0px",
                            fontSize: "16px",
                            fontWeight: "600"
                          }}
                          className="clippable-spacer"
                        >
                          No
                        </h4>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{
                            float: "left",
                            fontSize: "15px",
                            color: rnr2s >= 0 ? "green" : "red"
                          }}
                        >
                          {rnr2s !== 0 ? <span>{rnr2s}</span> : ""}
                        </div>
                        <div style={{ marginLeft: "10px", display: "none" }}>
                          &nbsp;&nbsp; <span></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </h3>

          <div className="price-row-box-new">
            <a
              className="price-price price-back"
              style={{
                background: "#e8f6fc"
              }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-back"
              style={{ background: "#e8f6fc" }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-back mb-show"
              data-team=""
              data-market-type="tie"
              data-bm-sr="2"
              style={{ backgroundColor: "rgb(141, 210, 240)" }}
              onClick={() =>
                showBetSlip("b", "No", sectionId2, r2b, childCatMid)
              }
            >
              <div id="runner2b1span_tie">
                <span className="price-odd">{r2b}</span>
                <span className="price-amount">{rate3}</span>
              </div>
            </a>

            <a
              className="price-price price-lay ml-4 mb-show"
              data-team=""
              data-market-type="tie"
              data-bm-sr="2"
              style={{ backgroundColor: "rgb(254, 175, 178)" }}
              onClick={() =>
                showBetSlip("l", "No", sectionId2, r2l, childCatMid)
              }
            >
              <div id="runner2l1span_tie">
                <span className="price-odd">{r2l}</span>
                <span className="price-amount">{rate4}</span>
              </div>
            </a>

            <a
              className="price-price price-lay"
              style={{ background: "#fce3e4" }}
            >
              <div>&nbsp;</div>
            </a>

            <a
              className="price-price price-lay mr-4"
              style={{ background: "#fce3e4" }}
            >
              <div>&nbsp;</div>
            </a>

            <div
              className="suspended-overlap"
              style={{ display: team2Status == "ACTIVE" ? "" : "none" }}
            >
              Suspended
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Tie;